module.exports = __webpack_public_path__ + "static/img/xiaoyisi.c44943c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/xiaoyisi.png
// module id = Nojl
// module chunks = 96